export enum MILITARY_TRAVEL_TYPE {
  OFFICIAL_ORDERS = 'Orders',
  LEISURE_TRAVEL = 'Leisure',
  NONE = 'None',
}
